/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'landing',
        title: 'Acount Manager',
        subtitle: 'Gestor de cuenta',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'landing.dashboard',
                title: 'Página Principal',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/account',
            },
            {
                id: 'apps.information',
                title: 'Información Personal',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/apps/information',
            },
            {
                id: 'apps.security',
                title: 'Seguridad',
                type: 'basic',
                icon: 'heroicons_outline:lock-closed',
                link: '/apps/security',
            },
            {
                id: 'apps.payments',
                title: 'Pagos y Suscripciones',
                type: 'basic',
                icon: 'heroicons_outline:credit-card',
                link: '/apps/payments',
            },
            {
                id: 'divider-1',
                type: 'divider',
            },
            {
                id: 'apps.settings',
                title: 'Configuración',
                type: 'basic',
                icon: 'heroicons_outline:cog-8-tooth',
                link: '/pages/settings',
            },
            
        ],
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
